import {
  TITLE,
  HEADER_Z_INDEX,
  NAV_TOGGLE,
  NAV_TRIGGER_FOCUS,
  REPORT_MENU,
  REPORT_LINK,
  REPORT_TICKET,
  PAGE_RESET,
  REPORT_MENU_RESET,
} from '../../actionTypes/Page/Page';
import Constants from '../../Constants';
import Api from '../../Api';
import { onErrorMsg } from '../FlashMessage/FlashMessages';

const api = new Api();

export const setPageTitle = (title) => {
  return (dispatch) => {
    const payload = [Constants.defaultPageTitle, title].filter((v) => !!v).join(' - ');
    window.document.title = payload;
    dispatch({ type: TITLE, payload });
  };
};

const getPageHeaderZIndexSuccess = (headerZIndexToggle) => {
  return {
    type: HEADER_Z_INDEX,
    headerZIndexToggle: headerZIndexToggle,
  };
}

export const getPageHeaderZIndex = (status) => {
  return (dispatch) => {
    dispatch(getPageHeaderZIndexSuccess(status));
  };
};

const getSideNavToggleSuccess = (sideNavToggle) => {
  return {
    type: NAV_TOGGLE,
    sideNavToggle: sideNavToggle,
  };
}

export const triggerNavFocus = () => {
  return {
    type: NAV_TRIGGER_FOCUS,
  };
}

const getReportMenuSuccess = (reportMenus) => {
  return {
    type: REPORT_MENU,
    reportMenus: reportMenus,
  };
}

export const cleanReportMenu = () => {
  return {
    type: REPORT_MENU_RESET,
  };
}

export const resetPageState = () => {
  return (dispatch) => {
    dispatch({
      type: PAGE_RESET
    });
  };
}

const getReportLinkSuccess = (reportLink) => {
  return {
    type: REPORT_LINK,
    reportLink: reportLink,
  };
}

const getReportTicketSuccess = (reportTicket) => {
  return {
    type: REPORT_TICKET,
    reportTicket: reportTicket,
  };
}

export const getSideNavToggle = (status) => {
  return (dispatch) => {
    dispatch(getSideNavToggleSuccess(status));
  };
};

export const getReportLink = (reportData) => {
  const reportLink = {
    reportUrl: reportData.reportUrl,
    originalUrl: reportData.originalUrl,
    reportDisplayName: reportData.reportDisplayName,
    hideDownload: reportData.hideDownload,
    hideExport: reportData.hideExport,
    filterByCohort: reportData.filterByCohort,
    passByUD: reportData.passByUD,
    saved: reportData.saved,
    cohortObj: reportData.cohortObj,
    exportWorkSheetName: reportData.exportWorkSheetName,
  };
  return (dispatch) => {
    dispatch(getReportLinkSuccess(reportLink));
  };
};

export const setReportMenu = (data) => {
  return (dispatch) => {
    dispatch(getReportMenuSuccess(data));
  };
};

export const getReportMenu = (clientId) => {
  return async (dispatch) => {
    const url = `${Constants.apiUrls.dashboard}${clientId !== '' ? ('?clientId=' + clientId) : ''}`;
    try {
      dispatch(getReportMenuSuccess({ clientId }));
      const { dashboard, reportMenus } = await api.getData(url);
      dispatch(getReportMenuSuccess({ clientId, dashboard, reportMenus }));
    } catch (e) {
      dispatch(cleanReportMenu());
      if (e.cancelled) {
        return;
      }
      console.error(e);
      dispatch(onErrorMsg('Some problem, can\'t load dashboard from server!'));
    }
  };
};

export const getReportTicket = () => {
  return (dispatch) => {
    const url = Constants.apiUrls.reportTicket;
    api.getData(url).then((resp) => {
      dispatch(getReportTicketSuccess(resp));
    });
  };
};
